export default "__VITE_ASSET__8921e2ef__"